import { instance } from "../apiclient";
import { CreateOrderObject, CreateGiftOrderObject } from "./Utilities";
import store from "../../store/index";
import { ReplaceAll } from "../helpers/stringHelper";
import uuid from "uuid/v1";
// import { DateTime } from "luxon";

export class DefaultPaymentHandler {
  MakePayment(
    guid,
    card,
    user,
    resturant,
    orderInfo,
    guestUserId,
    isGift = false,
    AppliedCouponList = [],
    loyalty = { RedeemPoints: 0, RewardPoints: 0 },
    twoStepPayment = false
  ) {
    var orderModel;
    if (isGift) {
      orderModel = CreateGiftOrderObject(
        store.state.giftShoppingCart,
        store.getters.giftCartValue,
        user,
        resturant,
        card,
        guid,
        orderInfo
      );
    } else {
      let priceItem = {
        totalPrice: store.getters.getTotalPrice,
        subTotalPrice: store.getters.cartValue,
        totalTax: store.getters.totaltax,
        freeOrderItems: store.getters.getFreeOrderItems,
        discountTax: store.getters.discountTax,
        discountExcludingTax: store.getters.discountExcludingTax,
        bankCardSurcharge: store.getters.getSurchargeBankAmount,
        pOSSurchargeTax: store.getters.getSurchargeHolidayValidTax,
        pOSSurchargeExcludingTax: store.getters.getSurchargeAmount,
        surchargeTransactions: store.getters.getSurchargeTransactions
      };
      orderModel = CreateOrderObject(
        store.state.shoppingCart,
        priceItem,
        user,
        resturant,
        card,
        guid,
        orderInfo,
        guestUserId,
        store.getters.priceTriggerOutcomes
      );
    }
    if (twoStepPayment) {
      // var date = DateTime.local();
      // orderModel.PaymentTransactions = [
      //   {
      //     Amount: orderModel.PaymentTransactions[0].Amount,
      //     CardType: null,
      //     PaymentMethod: "SuperPay Payment",
      //     ProviderType: 0,
      //     Status: 0,
      //     TransactionTime: date.toFormat("yyyy-MM-ddTHH:mm:sszzz"),
      //     PaymentType: 21,
      //     UniqueID: uuid()
      //   }
      // ];
      orderModel.PaymentGateway = 6;
    }
    const trackingOrderModel = {
      TrackingOrder: {
        ...orderModel,
        AppliedCouponCodes: AppliedCouponList,
        RoomNumber: orderInfo.roomNumber,
        Tables: [{ Name: orderInfo.tableNumber }],
        ...loyalty
      }
    };
    if (user.IsGuest) {
      Object.defineProperty(trackingOrderModel, "GuestUser", {
        value: {
          FirstName: user.FirstName,
          LastName: user.LastName,
          Email: user.Email,
          CreateUserForGuest: user.CreateUserForGuest
        },
        enumerable: true
      });
    }
    if (card && Object.keys(card).length != 0) {
      if (isGift || (!card.exclude && store.getters.getTotalPrice > 0)) {
        let ExpiryYear = card.expYear;
        if (card.expYear.length != 4) {
          ExpiryYear = "20" + card.expYear.trim();
        }
        Object.defineProperty(trackingOrderModel, "Card", {
          value: {
            CardHolder: card.holder,
            CardNumber: ReplaceAll(card.number, " ", ""),
            ExpiryYear: ExpiryYear,
            ExpiryMonth: card.expMonth.trim(),
            Cvv: card.cvc,
            ForceUseSandboxPayment:
              process.env.NODE_ENV === "production"
                ? "false"
                : true
          },
          enumerable: true
        });
      }
    }
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }

  Reorder(orderItem) {
    var order = Object.assign({}, orderItem);
    var guid = uuid();
    order.OnlineOrderStatus = 1;
    order.CreatedOn = new Date().toUTCString();
    order.InvoiceNumber = "";
    order.OnlineOrderStatusDescription = "";
    order.PaymentTransactions = [
      {
        Amount: order.PaymentTransactions[0].Amount
      }
    ];
    order.ScheduledTime = new Date().toUTCString();
    delete order.IsTimeOut;
    for (var tempItem of order.OrderItems) {
      tempItem.CreatedOn = new Date().toUTCString();
      tempItem.UDID = uuid();
      for (var tempExtra of tempItem.OrderExtras) {
        tempExtra.UDID = uuid();
      }
    }
    order.UDID = guid;
    const trackingOrderModel = {
      TrackingOrder: {
        ...order
      }
    };
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }

  PrepairPaymentUrl(orderDetails) {
    var data = {
      PaymentType: orderDetails.PaymentType,
      StoreId: orderDetails.storeId,
      OrderId: orderDetails.orderId,
      UserId: orderDetails.userId,
      AppName: "Online Ordering",
      TotalAmount: orderDetails.totalAmount,
      ReturnUrl: document.location.href,
      IsMobile: orderDetails.isMobile
    };

    return instance.post("supaypayment/supaypaymentstart", data);
  }
}
